
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.896","height":"14.75"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"transform":"translate(.5 2.798)"}},[_c('line',{attrs:{"x1":".73"}}),_c('line',{attrs:{"x1":".73","transform":"translate(0 5.254)"}}),_c('line',{attrs:{"x1":".73","transform":"translate(0 10.507)"}})]),_c('path',{attrs:{"d":"M1.23.5v13.754h15.166"}}),_c('g',{attrs:{"transform":"rotate(180 2.777 7.161)"}},[_c('rect',{attrs:{"width":"1.789","height":"6.789","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":".789","height":"5.789"}})]),_c('g',{attrs:{"transform":"rotate(180 4.777 7.161)"}},[_c('rect',{attrs:{"width":"1.789","height":"8.789","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":".789","height":"7.789"}})]),_c('g',{attrs:{"transform":"rotate(180 6.777 7.161)"}},[_c('rect',{attrs:{"width":"1.789","height":"5.789","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":".789","height":"4.789"}})])])])
          )
        }
      }
    